import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { NotificationsUtils } from '../utils';
import { Routes as routes } from '../navigation';
import { UserActions, NavigationActions, ContextActions, ConsultationsActions, PracticeActions } from '../actions';
import { SwitchAccount, TitleBar, NavBar, ConsultationsResolved, ConsultationsActive, AppointmentsList, ConsultationsUnassigned, ConsultationsList } from  '../components'

class FrontDeskConsultationsScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  componentDidMount() {
    let location = this.getCurrentLocation();
    if (location && location._id) {
      this.props.contextActions.setSelectedLocation(location._id);
    }
    this.props.consultationsActions.getRefreshedConsultations(true);
    this.props.contextActions.fetchDataForScreenAndRole('consultations');
  }

  renderContentContainers = () => {
    let notificationsDict = this.props.notifications && this.props.notifications.notificationsConsultationsDict ? this.props.notifications.notificationsConsultationsDict : {};
    let location          = this.getCurrentLocation();
    let location_id       = location && location._id ? location._id : '';
    let appointment_ids = this.props.schedule.practiceAppointmentIds;
    let practice        = this.props.practice && this.props.practice.info ? this.props.practice.info : null;
    let hide_unassigned = practice && practice.provider_selection_disabled && practice.provider_selection_disabled === false ? true : false;
    let is_front_desk   = true;
    let preview_consulations = this.props.consultations && this.props.consultations.previewConsultations ? this.props.consultations.previewConsultations : {};

    return <div className="flex-container screen-main-content">
        <div className="screen-container-column">
          <AppointmentsList
            title='Upcoming Appointments'
            token={this.props.user.auth.token}
            displayLimit={5}
            displayOnlyUpcoming={true}
            appointments={this.props.schedule.appointmentsDict}
            appointmentsIds={appointment_ids}
            consultations={this.props.consultations.allConsultations}
            users={this.props.user.users}
            consultationsActions={this.props.consultationsActions}
          />
          <ConsultationsList
            token={this.props.user.auth.token}
            consultations={preview_consulations}
            status='ACTIVE'
            consultationsActions={this.props.consultationsActions}
            hide_start_button={true}
            is_front_desk={true}
            notifications={notificationsDict}
          />
          { hide_unassigned ? null
            : <ConsultationsList
                token={this.props.user.auth.token}
                consultations={preview_consulations}
                status='RESOLVED'
                consultationsActions={this.props.consultationsActions}
                is_front_desk={true}
                notifications={notificationsDict}
              /> }
        </div>
        <div className="screen-container-column">
          { hide_unassigned
            ? <ConsultationsList
                token={this.props.user.auth.token}
                consultations={preview_consulations}
                status='RESOLVED'
                consultationsActions={this.props.consultationsActions}
                is_front_desk={true}
                notifications={notificationsDict}
              />
            : <ConsultationsList
                token={this.props.user.auth.token}
                consultations={preview_consulations}
                status='UNASSIGNED'
                consultationsActions={this.props.consultationsActions}
                is_front_desk={true}
                notifications={notificationsDict}
              /> }
            <ConsultationsList
                token={this.props.user.auth.token}
                consultations={preview_consulations}
                status='PROCESSING'
                consultationsActions={this.props.consultationsActions}
                is_front_desk={true}
                notifications={notificationsDict}
              />
        </div>
      </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <NavBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          selectedTab={'my_account'}
          practice={this.props.practice.practice}
          currentRoute={routes.FRONT_DESK_CONSULTATIONS}
        />

        { this.renderContentContainers() }

      </div>
    );
  }

  getCurrentLocation = () => {
    const frontDeskUsers = this.props.practice && this.props.practice.frontDeskUsers ? this.props.practice.frontDeskUsers : [];
    const currentUserId  = this.props.user.auth.user_id || '';
    const allLocations   = this.props.practice.locations || {};

    var currentLocation  = null;

    if (frontDeskUsers.length > 0 && currentUserId) {
      frontDeskUsers.forEach((user) => {
        const locationID = user.location_id;
        const location   = allLocations[locationID];
        if (user.user_id === currentUserId) {
          currentLocation  = location;
        }
      });
    }

    return currentLocation;
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
    consultations: state.consultations,
    notifications: state.notifications,
    schedule: state.schedule,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    consultationsActions: bindActionCreators(
     { ...ConsultationsActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FrontDeskConsultationsScreen)
